import React from "react";

const FooterPage = () => {
  return (
    <footer className="page-footer font-small pt-0" style={{marginTop: "-7.6px", backgroundColor: "#2196f3"}}>

        <div className="container">
            <div className="text-center py-5">
              <p>Finans App</p>
            </div>          
        </div>
 
        <div className="footer-copyright text-center py-3">
          <div className="container-fluid">© 2020 Copyright:<a href="https://www.progitek.no" alt=""> Ole Petter Kyrkjebø Hjønnevåg </a></div>
        </div>
    </footer>
  );
}

export default FooterPage;